import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={{ background: '#070a0f', borderTop: '1px solid var(--border)' }}>

      {/* Social row */}
      <div style={{ padding: '28px 32px 0', textAlign: 'center' }}>
        <div style={{ fontFamily: 'DM Mono', fontSize: 10, letterSpacing: 3, color: 'var(--muted)', textTransform: 'uppercase', marginBottom: 14 }}>
          Follow Us
        </div>
        <div style={{ display: 'flex', gap: 20, justifyContent: 'center', alignItems: 'center', marginBottom: 24 }}>
          <a href="https://www.instagram.com/og.techfab/" target="_blank" rel="noopener noreferrer"
            style={{ color: '#E1306C', transition: 'color 0.15s' }}
            onMouseEnter={e => (e.currentTarget.style.color = '#f77737')}
            onMouseLeave={e => (e.currentTarget.style.color = '#E1306C')}>
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
              <circle cx="12" cy="12" r="4.5"/>
              <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
            </svg>
          </a>
          <a href="https://www.facebook.com/ogtech.fab" target="_blank" rel="noopener noreferrer"
            style={{ color: '#1877F2', transition: 'color 0.15s' }}
            onMouseEnter={e => (e.currentTarget.style.color = '#4a9ff5')}
            onMouseLeave={e => (e.currentTarget.style.color = '#1877F2')}>
            <svg width="36" height="36" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
            </svg>
          </a>
          <a href="https://lnk.bio/og.techfab" target="_blank" rel="noopener noreferrer"
            style={{ color: 'var(--muted)', transition: 'color 0.15s' }}
            onMouseEnter={e => (e.currentTarget.style.color = 'var(--teal)')}
            onMouseLeave={e => (e.currentTarget.style.color = 'var(--muted)')}>
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
              <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
            </svg>
          </a>
        </div>
        <div style={{ borderBottom: '1px solid var(--border)', marginBottom: 24 }} />
      </div>

      {/* Bottom row */}
      <div style={{ padding: '0 32px 32px' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
          <img src="/images/OG-Tech Logo.png" alt="OG-TECH"
            style={{ height: 40, filter: 'drop-shadow(0 0 10px rgba(0,240,255,0.25))' }} />

          <div style={{ display: 'flex', gap: 24 }}>
            {[
              { to: '/', label: 'Shop' },
              { to: '/cart', label: 'Cart' },
              { to: '/about', label: 'About' },
            ].map(l => (
              <Link key={l.to} to={l.to} style={{
                fontFamily: 'DM Mono', fontSize: 11, letterSpacing: 2,
                textTransform: 'uppercase', color: 'var(--muted)',
              }}>
                {l.label}
              </Link>
            ))}
          </div>

          <span style={{ fontFamily: 'DM Mono', fontSize: 10, color: 'var(--muted)', letterSpacing: 1 }}>
            © {new Date().getFullYear()} OG-TECH LLC
          </span>
        </div>
      </div>
    </footer>
  );
}
